import importer from 'common/importer'
/* */
const Config = importer('Config')
const schema = Config.GRAPHQL_HASURA_SCHEMA
/* */
const getPhoneTypes = importer('GraphQL/Queries/getPhoneTypes')(schema)
const getEthnicityOptions = importer('GraphQL/Queries/getEthnicityOptions')(schema)
const getLanguages = importer('GraphQL/Queries/getLanguages')(schema)
const getMessages = importer('GraphQL/Queries/getMessages')(schema)
const getLoyaltyMilestones = importer('GraphQL/Queries/getLoyaltyMilestones')(schema)
const getCenters = importer('GraphQL/Queries/getCenters')(schema)
const getCentersForMobile = importer('GraphQL/Queries/getCentersForMobile')(schema)
const getGenders = importer('GraphQL/Queries/getGenders')(schema)
const getCountries = importer('GraphQL/Queries/getCountries')(schema)
const getAllStates = importer('GraphQL/Queries/getAllStates')(schema)
const getLoyaltyAchievementBadges = importer('GraphQL/Queries/getLoyaltyAchievementBadges')(schema)
const getRedeemPaused = importer('GraphQL/Queries/getRedeemPaused')(schema)
const getVendorRedeemPaused = importer('GraphQL/Queries/getVendorRedeemPaused')(schema)

export default {
  getPhoneTypes,
  getEthnicityOptions,
  getLanguages,
  getMessages,
  getLoyaltyMilestones,
  getCenters,
  getGenders,
  getCountries,
  getAllStates,
  getCentersForMobile,
  getLoyaltyAchievementBadges,
  getRedeemPaused,
  getVendorRedeemPaused
}
